// app/components/TopLoader.tsx
"use client"

import Loader from "nextjs-toploader"
import { useEffect } from "react"
import { usePathname } from "next/navigation"
import * as NProgress from "nprogress"

export const TopLoader = () => {
  const pathname = usePathname()

  useEffect(() => {
    const handleStart = () => NProgress.start()
    const handleStop = () => NProgress.done()

    // Listen to route events manually
    window.addEventListener("app-router-loading-start", handleStart)
    window.addEventListener("app-router-loading-stop", handleStop)

    return () => {
      window.removeEventListener("app-router-loading-start", handleStart)
      window.removeEventListener("app-router-loading-stop", handleStop)
    }
  }, [])

  // Fallback for pathname change (e.g., direct nav)
  useEffect(() => {
    NProgress.done()
  }, [pathname])

  return (
    <Loader
      color="#0051a2"
      initialPosition={0.08}
      crawlSpeed={200}
      height={3}
      crawl={true}
      showSpinner={false}
      easing="ease"
      speed={200}
      shadow="0 0 10px #2299DD,0 0 5px #2299DD"
    />
  )
}
